import React from "react";
import PropTypes from "prop-types";
import {useSelector} from "react-redux";

AppStoreItemData.propTypes = {
  path: PropTypes.string.isRequired,
  component: PropTypes.elementType.isRequired,
  dataField: PropTypes.string.isRequired,
  transformer: PropTypes.func,
};

function AppStoreItemData({component, dataField, transformer, ...props}) {
  const data = useSelector((state) => {
    return state.Collections?.data?.[props.path];
  });

  return React.createElement(
    component, {
      [dataField]: transformer ?
        transformer(data) :
        data,
      ...props,
    });
}

export default AppStoreItemData;
